import React, { Component } from 'react';
import { DatePicker  } from 'antd';
import moment from 'moment';

import { API_FORMAT } from 'constants/dates';
import withFormItem from 'components/hocs/withFormItem';

const disabledDateConfig = {
    past: (date) => moment(date).isBefore(moment(), 'day'),
    future: (date) => moment(date).isSameOrAfter(moment(), 'day'),
};

@withFormItem
export default class DateComponent extends Component {
    static defaultProps = {
        allowClear: true,
        format: "DD.MM.YYYY",
    }

    onChange = (date, dateStrings) => {
        const { field: { name }, form: { setFieldValue }, format } = this.props;

        setFieldValue(
            name,
            dateStrings ? moment(dateStrings, format).format(API_FORMAT) : undefined
        );
    }

    render() {
        const { field: { value } } = this.props;
        const { format, placeholder, disabled, allowClear, disabledDate } = this.props;

        const disabledDateFunction = disabledDateConfig[disabledDate] || disabledDate;
        const dateValue = value && moment(value, API_FORMAT).isValid() ? moment(value, API_FORMAT) : null;

        return (
            <DatePicker
                value={dateValue}
                onChange={this.onChange}

                allowClear={allowClear}
                placeholder={placeholder}
                disabled={disabled}
                format={format}
                disabledDate={disabledDateFunction}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/form/Date.js